import { useSetAtom } from 'jotai'
import { useNavigate } from 'react-router'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'

import routes from 'const/routes'

/**
 *
 *This function will allow users to be redirected to the Profile screen when they click Edit Profile
 */

const useProfileNavigate = () => {
  const navigate = useNavigate()
  const updateModalStatus = useSetAtom(modalStatusAtom)
  const setSelectedAccount = useSetAtom(selectedAccountAtom)

  const handleProfileClick = (guid: string) => {
    updateModalStatus('')
    setSelectedAccount(guid)
    setTimeout(() => {
      navigate(routes.PROFILE)
    }, 400)
  }

  return {
    handleProfileClick
  }
}

export default useProfileNavigate
